import { useMemo, useState, useRef, useEffect } from "books/act";

type Props = {
  cardId: string;
};

const IFRAME_BASE_URL_CARD_EMBED = "https://memoir.cards/embed/card/";
const IFRAME_INNER_PADDING = 8;

const CARD_MIN_WIDTH_DEFAULT = 242;
const CARD_MAX_WIDTH_DEFAULT = 380;
const IFRAME_MAX_CARD_WIDTH =
  (CARD_MAX_WIDTH_DEFAULT + CARD_MIN_WIDTH_DEFAULT) / 2;

const getIframeBound = (width: number) =>
  Math.min(IFRAME_MAX_CARD_WIDTH, Math.max(width, CARD_MIN_WIDTH_DEFAULT));

const CardButton = ({ cardId }: Props) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const [iframeBound, setIframeBound] = useState(0);

  useEffect(() => {
    if (!iframeRef.current) {
      return;
    }

    const resizeObserver = new ResizeObserver(([entry]) => {
      setIframeBound(getIframeBound(entry.contentRect.width));
    });

    resizeObserver.observe(iframeRef.current);

    return () => resizeObserver.disconnect();
  }, []);

  const iframeSrc = useMemo(
    () =>
      IFRAME_BASE_URL_CARD_EMBED +
      cardId +
      `?width=${iframeBound - IFRAME_INNER_PADDING}`,
    [cardId, iframeBound]
  );

  return (
    <iframe
      ref={iframeRef}
      title="Card Button"
      src={iframeSrc}
      style={{
        border: 0,
        aspectRatio: "4 / 6",
        width: "100%",
        borderRadius: 16,
        maxWidth: IFRAME_MAX_CARD_WIDTH + IFRAME_INNER_PADDING,
      }}
      allowFullScreen
      loading="lazy"
    />
  );
};

export default CardButton;
